<ng-template #loading>
    <div class="loading">
        <app-loading-dots></app-loading-dots>
    </div>
</ng-template>

<div class="container">
    <div class="row">
        <div
            class="col-12 col-md-6 col-lg-4"
            [ngClass]="{ 'offset-md-3 offset-lg-4': data.alignment === alignment.Center }"
        >
            <app-spot-headline *ngIf="data.headlineText as headlineText" [index]="data.spotIndex">
                {{ headlineText }}
            </app-spot-headline>
            <div
                *ngIf="data.richText"
                class="kk-rte rich-text"
                appInterceptLinks
                [innerHTML]="data.richText | safe: 'html'"
            ></div>
            <form class="form" [formGroup]="form" (submit)="onSubmit()" appHandleInvalidOnSubmit>
                <app-input-email [control]="form.controls['username']"></app-input-email>
                <div *ngIf="!loggingIn(); else loading" class="controls">
                    <div class="large-screen-button">
                        <app-icon-button iconPosition="after" variant="primary" iconName="arrow_right" type="submit">
                            {{ 'login.next' | translateSafe }}
                        </app-icon-button>
                    </div>
                    <!-- Medium and small phone button -->
                    <div class="small-screen-button">
                        <app-icon-button
                            [fullWidth]="true"
                            iconPosition="after"
                            variant="primary"
                            iconName="arrow_right"
                            type="submit"
                        >
                            {{ 'login.next' | translateSafe }}
                        </app-icon-button>
                    </div>

                    <div class="buttons-wrapper">
                        <div class="or-text-separator display-caption">{{ 'login.orText' | translateSafe }}</div>

                        <button type="button" class="vipps-login-button" (click)="loginWithVipps()">
                            <app-svg-icon iconName="vipps_log_in"></app-svg-icon>
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
